module.exports = __webpack_public_path__ + "img/modelo-restaurante.aa12f003.png";